// ─── MOTOR DE NOTIFICĂRI (în aplicație) ──────────────────────────────────────
// Rulează cât timp aplicația e deschisă. Livrarea în fundal (telefon blocat) vine la
// pasul Capacitor; aici verificăm periodic și declanșăm notificări pentru orele de
// medicamente, epuizarea stocului și reminderele de programări.
import { addDaysISO, todayISO, fmtD, shouldMedBeActiveOnDate } from './helpers';
import { t as trN } from './i18n';

export function fmNotify(title, body, tag){
  if(typeof Notification==="undefined" || Notification.permission!=="granted") return;
  try{
    if(navigator.serviceWorker && navigator.serviceWorker.ready){
      navigator.serviceWorker.ready
        .then(reg=>{ if(reg&&reg.showNotification) reg.showNotification(title,{body,tag,icon:"/logo192.png"}); else new Notification(title,{body,tag}); })
        .catch(()=>{ try{ new Notification(title,{body,tag}); }catch(e){} });
    } else new Notification(title,{body,tag});
  }catch(e){}
}
export function fmFired(k){ try{ return localStorage.getItem("fm_ntf_"+k)==="1"; }catch(e){ return false; } }
export function fmMark(k){ try{ localStorage.setItem("fm_ntf_"+k,"1"); }catch(e){} }
// Redă un sunet de alarmă sintetizat (Web Audio) — nu necesită fișiere audio și
// funcționează cât timp aplicația e deschisă. Cu telefonul blocat, sunetul propriu
// va veni prin notificarea nativă la pasul Capacitor.
let _fmAudioCtx = null;
export function playAlarm(sound){
  try{
    const AC = window.AudioContext || window.webkitAudioContext;
    if(!AC) return;
    _fmAudioCtx = _fmAudioCtx || new AC();
    const ctx = _fmAudioCtx;
    if(ctx.state==="suspended") ctx.resume();
    const patterns = {
      bip:      { type:"square", notes:[880,880,880], step:0.22, dur:0.18 },
      clopotel: { type:"sine",   notes:[1318,1568,2093,1568], step:0.16, dur:0.5 },
      melodie:  { type:"sine",   notes:[523,659,784,1047,784,1047], step:0.26, dur:0.28 },
      default:  { type:"triangle", notes:[784,988,784,988], step:0.28, dur:0.26 },
    };
    const p = patterns[sound] || patterns.default;
    const now = ctx.currentTime;
    p.notes.forEach((f,i)=>{
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.type = p.type; o.frequency.value = f;
      const t = now + i*p.step;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.35, t+0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t+p.dur);
      o.connect(g); g.connect(ctx.destination);
      o.start(t); o.stop(t+p.dur+0.02);
    });
  }catch(e){}
}
// Deblochează contextul audio la prima atingere a utilizatorului, ca sunetul declanșat
// mai târziu de un cronometru (alarma la ora medicamentului) să poată reda — browserele
// mobile blochează audio pornit fără o interacțiune recentă.
let _fmKeepAlive = null;
export function unlockAudio(){
  try{
    const AC = window.AudioContext || window.webkitAudioContext;
    if(!AC) return;
    _fmAudioCtx = _fmAudioCtx || new AC();
    if(_fmAudioCtx.state==="suspended") _fmAudioCtx.resume();
    const b = _fmAudioCtx.createBuffer(1,1,22050);
    const s = _fmAudioCtx.createBufferSource();
    s.buffer = b; s.connect(_fmAudioCtx.destination); s.start(0);
    // Keep-alive: o buclă silențioasă ține contextul „treaz", ca sunetul declanșat mai
    // târziu de un cronometru (nu de o atingere) să poată reda cât timp app-ul e în față
    if(!_fmKeepAlive){
      const buf = _fmAudioCtx.createBuffer(1, _fmAudioCtx.sampleRate, _fmAudioCtx.sampleRate);
      const src = _fmAudioCtx.createBufferSource();
      src.buffer = buf; src.loop = true;
      const g = _fmAudioCtx.createGain(); g.gain.value = 0;
      src.connect(g); g.connect(_fmAudioCtx.destination);
      src.start(0);
      _fmKeepAlive = src;
    }
  }catch(e){}
}
export function fmInQuietHours(ns){
  if(!ns.quiet_from || !ns.quiet_to) return false;
  const now=new Date(), cur=now.getHours()*60+now.getMinutes();
  const [fh,fm]=ns.quiet_from.split(":").map(Number), [th,tm]=ns.quiet_to.split(":").map(Number);
  const from=fh*60+fm, to=th*60+tm;
  if(from===to) return false;
  return from<to ? (cur>=from && cur<to) : (cur>=from || cur<to);
}
export function medDosesPerDay(med){
  if(med.scheduleType==="ondemand") return 0;
  if(med.scheduleType==="interval_hours"){ const h=parseFloat(med.intervalHours)||8; return h>0?24/h:0; }
  const sched=med.schedule||[];
  const sum=sched.reduce((a,s)=>a+(parseFloat(s.dose)||1),0);
  return sum || sched.length || 1;
}
// Predicție simplă a următoarei menstruații din datele de ciclu (independentă de CicluTab)
export function daysBetweenISO(a,b){ const[y1,m1,d1]=a.split("-").map(Number); const[y2,m2,d2]=b.split("-").map(Number); return Math.round((new Date(y2,m2-1,d2)-new Date(y1,m1-1,d1))/864e5); }
export function predictNextPeriod(cycleData){
  const data=cycleData||{};
  const periods=data.periods||[];
  if(!periods.length) return null;
  const sorted=[...new Set(periods)].sort();
  const starts=[sorted[0]];
  for(let i=1;i<sorted.length;i++){ if(addDaysISO(sorted[i-1],1)!==sorted[i]) starts.push(sorted[i]); }
  const realLast=starts[starts.length-1];
  let cycleLen;
  if(data.smartCycle===false){ cycleLen=data.manualCycleLen||28; }
  else {
    const diffs=[];
    for(let i=1;i<starts.length;i++){ const dd=daysBetweenISO(starts[i-1],starts[i]); if(dd>=15&&dd<=60) diffs.push(dd); }
    cycleLen=diffs.length? Math.round(diffs.reduce((a,b)=>a+b,0)/diffs.length) : (data.manualCycleLen||28);
  }
  let next=addDaysISO(realLast, cycleLen);
  const today=todayISO();
  let guard=0;
  while(next<today && guard++<24){ next=addDaysISO(next, cycleLen); }
  return next;
}
export function runNotificationChecks(d){
  const ns=d.ns;
  if(!ns || !ns.enabled) return;
  if(typeof Notification==="undefined" || Notification.permission!=="granted") return;
  if(fmInQuietHours(ns)) return;
  const now=new Date();
  const today=todayISO();
  const curMin=now.getHours()*60+now.getMinutes();
  const meds=d.meds||[], events=d.events||{};

  if(ns.med_time_enabled){
    meds.forEach(med=>{
      if(!med.active || med.scheduleType==="ondemand") return;
      if(!shouldMedBeActiveOnDate(med, today)) return;
      (med.schedule||[]).forEach(s=>{
        if(!s.time) return;
        const [hh,mm]=s.time.split(":").map(Number);
        const t=hh*60+mm;
        if(curMin>=t && curMin<t+2){
          const key=`medt_${med.id}_${today}_${s.time}`;
          if(!fmFired(key)){ fmMark(key); fmNotify("💊 "+med.name, `${trN("E ora")} ${s.time} — ${s.dose||1} ${trN("doză")}.`, key); playAlarm(ns.sound); }
        }
      });
    });
  }

  if(ns.med_stock_enabled){
    meds.forEach(med=>{
      // opt-out: alerta e activă implicit când comutatorul global e pornit;
      // se dezactivează doar dacă notifyStock e explicit false pe medicament
      if(!med.active || med.notifyStock===false) return;
      const per=medDosesPerDay(med);
      if(per<=0) return;
      const daysLeft=(parseFloat(med.stock)||0)/per;
      const thr=med.notifyStockDays || ns.stock_days_before || 3;
      if(daysLeft<=thr){
        const key=`stock_${med.id}_${today}`;
        if(!fmFired(key)){ fmMark(key); fmNotify("🔔 "+trN("Stoc pe terminate"), `${med.name}: ${trN("îți mai ajunge pentru")} ~${Math.max(0,Math.floor(daysLeft))} ${trN("zile")}.`, key); }
      }
    });
  }

  if(ns.appt_enabled){
    Object.entries(events).forEach(([dk,list])=>{
      (list||[]).forEach(e=>{
        const rh=e.reminderHours;
        if(!rh || rh<=0 || e.isNote) return;
        const time=e.time||"09:00";
        const [hh,mm]=time.split(":").map(Number);
        const evDate=new Date(+dk.slice(0,4), +dk.slice(5,7)-1, +dk.slice(8,10), hh||0, mm||0);
        const remindAt=new Date(evDate.getTime()-rh*3600*1000);
        if(now>=remindAt && now<evDate){
          const key=`appt_${e.id}`;
          if(!fmFired(key)){ fmMark(key); fmNotify("📅 "+trN("Programare medicală"), `${e.spec||e.title||trN("Programare")} — ${fmtD(dk)} ${time}.`, key); }
        }
      });
    });
  }

  // Menstruație — opțional, cu X zile înainte de data estimată, la ora aleasă
  const cyc=d.cycleData;
  if(cyc && cyc.notify && cyc.notify.enabled){
    // Preferă data exactă calculată și afișată în tab-ul Ciclu; predictorul propriu e doar rezervă
    const next=cyc.predictedNext || predictNextPeriod(cyc);
    if(next){
      const daysBefore=cyc.notify.daysBefore||3;
      const [nh,nm]=(cyc.notify.time||"09:00").split(":").map(Number);
      const notifyMin=(nh||0)*60+(nm||0);
      const daysUntil=daysBetweenISO(today, next);
      // Fereastră LARGĂ: se declanșează oricând după ora aleasă (nu doar fix la ora aia),
      // la prima rulare din ziua respectivă — altfel notificarea se pierdea dacă
      // aplicația nu era deschisă exact în acel minut. Cheia limitează la o dată pe zi.
      if(daysUntil>=0 && daysUntil<=daysBefore && curMin>=notifyMin){
        const key=`cycle_${next}_${today}`;
        if(!fmFired(key)){
          fmMark(key);
          const body=daysUntil===0 ? trN("Menstruația e estimată azi.")
            : daysUntil===1 ? trN("1 zi rămasă până la menstruație.")
            : `${daysUntil} ${trN("zile rămase până la menstruație.")}`;
          fmNotify("🌸 "+trN("Menstruație"), body, key);
        }
      }
    }
  }
}
